import {
    CREATECOMORBIDITYTYPE,
    GETCOMORBIDITYTYPE,
    UPDATECOMORBIDITYTYPE,
    DELETECOMORBIDITYTYPE,
    CREATECOMORBIDITYHEAD,
    GETCOMORBIDITYHEAD,
    UPDATECOMORBIDITYHEAD,
    DELETECOMORBIDITYHEAD,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATECOMORBIDITYTYPE:
            return {
                ...state,
                comorbiditytypeSaveStatus: action.payload.success,
            }
        case GETCOMORBIDITYTYPE:
                return {
                        ...state,
                        comorbiditytypeList: action.payload.data,
                        }
        case UPDATECOMORBIDITYTYPE:
                return {
                        ...state,
                        comorbiditytypeUpdateStatus: action.payload.success,
                        }   

        case DELETECOMORBIDITYTYPE:
                 return {
                     ...state,
                     comorbiditytypeDeleteStatus: action.payload.success,
                        } 
        case CREATECOMORBIDITYHEAD:
                return {
                        ...state,
                        comorbidityheadSaveStatus: action.payload.success,
                        }
        case GETCOMORBIDITYHEAD:
                 return {
                        ...state,
                        comorbidityheadList: action.payload.data,
                        }
        case UPDATECOMORBIDITYHEAD:
                return {
                        ...state,
                        comorbidityheadUpdateStatus: action.payload.success,
                        }   
                
        case DELETECOMORBIDITYHEAD:
                    return {
                            ...state,
                            comorbidityheadDeleteStatus: action.payload.success,
                            } 
        default:
                return state
                      }
                 }